import React from 'react'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { FormGroup, FormText } from 'reactstrap'

const normalizeClienteSearchValue = (value = '') =>
  String(value).trim().toLowerCase().replace(/\s+/g, ' ')

const filterClienteOption = (candidate, inputValue) => {
  const normalizedInputValue = normalizeClienteSearchValue(inputValue)

  if (!normalizedInputValue) {
    return true
  }

  return normalizeClienteSearchValue(candidate.label).includes(normalizedInputValue)
}

export default function ClienteSelect({
  id,
  label = 'Cliente',
  clienti = [],
  selectedClientId = '',
  onChange,
  helpText = null,
  placeholder = 'Seleziona un cliente',
  isRequired = false,
  isClearable = null,
  showCreateLink = false,
  createLinkTo = '/client-creation/create',
  createLinkLabel = 'Non trovi il tuo cliente? crealo',
}) {
  const options = clienti.map((cliente) => ({
    value: String(cliente.id),
    label: cliente.nome,
  }))

  const selectedOption =
    options.find((option) => option.value === String(selectedClientId || '')) || null

  return (
    <FormGroup>
      {label ? (
        <label htmlFor={id} className="form-control-label">
          {label}
        </label>
      ) : null}
      <Select
        inputId={id}
        name={id}
        classNamePrefix="react-select"
        options={options}
        value={selectedOption}
        onChange={(option) => onChange(option?.value || '')}
        placeholder={placeholder}
        isSearchable
        isClearable={isClearable ?? !isRequired}
        filterOption={filterClienteOption}
        noOptionsMessage={() => 'Nessun cliente trovato'}
      />
      {helpText ? <FormText color="muted">{helpText}</FormText> : null}
      {showCreateLink ? (
        <FormText color="muted">
          <Link to={createLinkTo}>{createLinkLabel}</Link>
        </FormText>
      ) : null}
    </FormGroup>
  )
}
